import { isString } from '@grandvisionhq/utils';
import { getProductInventoryChannels } from '../utils/get-product-inventory-channels.js';
import { getProductPrice } from '../utils/get-product-price.js';
import { getProductTags } from '../utils/get-product-tags.js';
import { getProductMedia } from '../utils/get-product-media.js';
import { getMetaTitle, getMetaDescription } from '../utils/get-product-seo-info.js';
import { getProductImageUrl } from '../utils/get-product-image-url.js';

const mapServerToVariantBase = (serverVariant, serverProduct, slug, locale)=>{
    var ref;
    const price = getProductPrice(serverVariant);
    const { variantTypeDetails , description: variantDescription , displayName , bestPrice , loyaltyPoints ,  } = serverVariant;
    const { description: productDescription  } = serverProduct;
    if (!price) {
        console.error(`Cannot render a variant that does not have a price`);
        return;
    }
    const description = [
        variantDescription,
        productDescription
    ].find(isString);
    const tags = getProductTags(variantTypeDetails.tags, price, locale);
    const media = getProductMedia(serverVariant.media);
    const metaTitle = getMetaTitle(serverVariant, serverProduct);
    const metaDescription = getMetaDescription(serverVariant, serverProduct);
    const ogImageUrl = getProductImageUrl(serverVariant.media);
    const inventoryChannels = getProductInventoryChannels(serverVariant.inventory);
    let recommendedCategoryKey;
    // recommendedCategoryKey has not yet been implemented on the BE for Frames,
    // but the FE should treat it as possible for any product type
    if ('recommendedCategoryKey' in serverVariant.variantTypeDetails) {
        var _recommendedCategoryKey;
        recommendedCategoryKey = (_recommendedCategoryKey = serverVariant.variantTypeDetails.recommendedCategoryKey) !== null && _recommendedCategoryKey !== void 0 ? _recommendedCategoryKey : undefined;
    }
    var _header, ref1;
    return {
        // bestPrice is returned as cent amount, but other prices are returned
        // as decimal amounts. Therefore, bestPrice is mapped to decimal amount to allow comparisons
        // between best price & product prices
        bestPrice: bestPrice ? bestPrice / 100 : undefined,
        channelAvailability: variantTypeDetails.channelAvailability,
        loyaltyPoints: loyaltyPoints !== null && loyaltyPoints !== void 0 ? loyaltyPoints : undefined,
        displayName,
        description,
        shortDescription: (_header = serverVariant.header) !== null && _header !== void 0 ? _header : undefined,
        sku: serverVariant.sku,
        slug,
        variantUsps: serverVariant.usps,
        tags,
        isExcludedFromCheckout: !!serverVariant.isExcludedFromCheckout,
        media,
        price,
        recommendedCategoryKey,
        seoConfig: {
            metaTitle,
            metaDescription,
            ogImageUrl
        },
        isPublished: serverVariant.isPublished,
        stock: {
            enableStockIndicator: !serverVariant.isExcludedFromCheckout,
            isAllowBackOrder: !!serverVariant.isAllowBackOrder,
            stockCount: (ref1 = (ref = serverVariant.inventory) === null || ref === void 0 ? void 0 : ref.totalQuantity) !== null && ref1 !== void 0 ? ref1 : 0
        },
        inventoryChannels
    };
};

export { mapServerToVariantBase };
//# sourceMappingURL=map-server-to-variant-base.js.map
